import React from 'react';
import '../../css/JuanIS/JuanISClassSchedule.css';

function JuanISClassSchedule() {
  // Sample schedule data
  const scheduleData = [
    {
      section: 'EN6E9',
      subjects: 'CTRMID/EN/01',
      day: 'Monday, Wednesday, Friday',
      schedule: '10:00 - 11:30 A.M.',
      room: 'RM 4884',
      professor: 'Ms. Marlyn Mabatid',
      status: 'Enrolled',
      units: '3.0'
    },
    {
      section: 'EN6E9',
      subjects: 'CTRMID/EN/01',
      day: 'Monday, Wednesday, Friday',
      schedule: '10:00 - 11:30 A.M.',
      room: 'RM 4884',
      professor: 'Ms. Marlyn Mabatid',
      status: 'Enrolled',
      units: '3.0'
    },
    {
      section: 'EN6E9',
      subjects: 'CTRMID/EN/01',
      day: 'Monday, Wednesday, Friday',
      schedule: '10:00 - 11:30 A.M.',
      room: 'RM 4884',
      professor: 'Ms. Marlyn Mabatid',
      status: 'Enrolled',
      units: '3.0'
    },
    {
      section: 'EN6E9',
      subjects: 'CTRMID/EN/01',
      day: 'Monday, Wednesday, Friday',
      schedule: '10:00 - 11:30 A.M.',
      room: 'RM 4884',
      professor: 'Ms. Marlyn Mabatid',
      status: 'Enrolled',
      units: '3.0'
    },
    {
      section: 'EN6E9',
      subjects: 'CTRMID/EN/01',
      day: 'Monday, Wednesday, Friday',
      schedule: '10:00 - 11:30 A.M.',
      room: 'RM 4884',
      professor: 'Ms. Marlyn Mabatid',
      status: 'Enrolled',
      units: '3.0'
    }
  ];

  return (
    <div className="juanis-class-schedule-container">
      <div className="juanis-class-schedule-header">
        <h1>Class Schedule</h1>
      </div>

      <div className="juanis-class-schedule-subtitle">
        <p>This is your schedule tracker! Stay updated on what is coming!</p>
      </div>

      <div className="juanis-class-schedule-content">
        <h2>Schedule</h2>
        <div className="juanis-class-schedule-table-container">
          <table className="juanis-class-schedule-table">
            <thead>
              <tr>
                <th>Section</th>
                <th>Subjects</th>
                <th>Day</th>
                <th>Schedule</th>
                <th>Room</th>
                <th>Professor</th>
                <th>Status</th>
                <th>Units</th>
              </tr>
            </thead>
            <tbody>
              {scheduleData.map((item, index) => (
                <tr key={index}>
                  <td>{item.section}</td>
                  <td>{item.subjects}</td>
                  <td>{item.day}</td>
                  <td>{item.schedule}</td>
                  <td>{item.room}</td>
                  <td>{item.professor}</td>
                  <td>{item.status}</td>
                  <td>{item.units}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="juanis-class-schedule-action-buttons">
          <button className="juanis-class-schedule-download-button">
            <span>📥</span> Download as PDF
          </button>
          <button className="juanis-class-schedule-print-button">
            <span>🖨️</span> Print
          </button>
        </div>
      </div>
    </div>
  );
}

export default JuanISClassSchedule;